<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('system.configName')" prop="configName">
        <a-input disabled v-model="form.configName" :placeholder="$t('system.inputPlaceholder')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('system.configGroup')" prop="configGroup">
        <a-input disabled v-model="form.configGroup" :placeholder="$t('system.inputPlaceholder')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('system.configKey')" prop="configKey">
        <a-input disabled v-model="form.configKey" :placeholder="$t('system.inputPlaceholder')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('system.configType')" prop="configType">
        <a-radio-group disabled v-model="form.configType" button-style="solid">
          <a-radio-button v-for="(d, index) in configTypeOptions" :key="index" :value="d.value">
            {{ d.label }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>

      <template v-if="(form.configKey == 'sendVipDays' && form.configGroup == 'sendVipDays') || (form.configKey == 'min' && form.configGroup == 'withdraw')|| (form.configKey == 'ratio' && form.configGroup == 'withdraw')">
        <a-form-model-item :label="$t('system.configValue')" prop="configValue">
          <a-input v-model="form.configValue" :placeholder="$t('system.inputPlaceholder')" v-if="form.configType=== '1' " />
          <a-textarea v-model="form.configValue" :placeholder="$t('system.inputPlaceholder')" v-if="form.configType=== '2' " />
          <editor editorValue="configValue" v-model="form.configValue" v-if="form.configType=== '3' " />

          <a-upload
            listType="picture-card"
            class="avatar-uploader"
            v-model="form.configValue"
            :showUploadList="false"
            :customRequest="handleChange"
            v-if="form.configType=== '4' "
          >
            <img v-if="form.configValue" :src="form.configValue" alt="logo"
                 style="height:50px;width:50px"/>
            <div v-else>
              <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
            </div>
          </a-upload>
        </a-form-model-item>
      </template>


      <template v-else>
        <a-form-model-item :label="$t('system.configValue')" prop="configValueIn">
          <a-input v-model="form.configValueIn" :placeholder="$t('system.inputPlaceholder')" v-if="form.configType=== '1' " />
          <a-textarea v-model="form.configValueIn" :placeholder="$t('system.inputPlaceholder')" v-if="form.configType=== '2' " />
          <editor editorValue="configValueIn" v-model="form.configValueIn" v-if="form.configType=== '3' " />
          <a-upload
            listType="picture-card"
            class="avatar-uploader"
            v-model="form.configValueIn"
            :showUploadList="false"
            :customRequest="handleChangeIn"
            v-if="form.configType=== '4' "
          >
            <img v-if="form.configValueIn" :src="form.configValueIn" alt="logo"
                 style="height:50px;width:50px"/>
            <div v-else>
              <a-icon :type="uploadLoadingIn ? 'loading' : 'plus'"/>
            </div>
          </a-upload>
        </a-form-model-item>

        <a-form-model-item :label="$t('system.configValueEn')" prop="configValueEn">
          <a-input v-model="form.configValueEn" :placeholder="$t('system.inputPlaceholder')" v-if="form.configType=== '1' " />
          <a-textarea v-model="form.configValueEn" :placeholder="$t('system.inputPlaceholder')" v-if="form.configType=== '2' " />
          <editor editorValue="configValueEn" v-model="form.configValueEn" v-if="form.configType=== '3' " />
          <a-upload
            listType="picture-card"
            class="avatar-uploader"
            v-model="form.configValueEn"
            :showUploadList="false"
            :customRequest="handleChangeEn"
            v-if="form.configType=== '4' "
          >
            <img v-if="form.configValueEn" :src="form.configValueEn" alt="logo"
                 style="height:50px;width:50px"/>
            <div v-else>
              <a-icon :type="uploadLoadingEn ? 'loading' : 'plus'"/>
            </div>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item :label="$t('system.configValueCn')" prop="configValueCn">
          <a-input v-model="form.configValueCn" :placeholder="$t('system.inputPlaceholder')" v-if="form.configType=== '1' " />
          <a-textarea v-model="form.configValueCn" :placeholder="$t('system.inputPlaceholder')" v-if="form.configType=== '2' " />
          <editor editorValue="configValueCn" v-model="form.configValueCn" v-if="form.configType=== '3' " />
          <a-upload
            listType="picture-card"
            class="avatar-uploader"
            v-model="form.configValueCn"
            :showUploadList="false"
            :customRequest="handleChangeCn"
            v-if="form.configType=== '4' "
          >
            <img v-if="form.configValueCn" :src="form.configValueCn" alt="logo"
                 style="height:50px;width:50px"/>
            <div v-else>
              <a-icon :type="uploadLoadingCn ? 'loading' : 'plus'"/>
            </div>
          </a-upload>
        </a-form-model-item>

        <a-form-model-item :label="$t('system.configValueArabic')" prop="configValue">
          <a-input v-model="form.configValue" :placeholder="$t('system.inputPlaceholder')" v-if="form.configType=== '1' " />
          <a-textarea v-model="form.configValue" :placeholder="$t('system.inputPlaceholder')" v-if="form.configType=== '2' " />
          <editor editorValue="configValue" v-model="form.configValue" v-if="form.configType=== '3' " />

          <a-upload
            listType="picture-card"
            class="avatar-uploader"
            v-model="form.configValue"
            :showUploadList="false"
            :customRequest="handleChange"
            v-if="form.configType=== '4' "
          >
            <img v-if="form.configValue" :src="form.configValue" alt="logo"
                 style="height:50px;width:50px"/>
            <div v-else>
              <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
            </div>
          </a-upload>
        </a-form-model-item>

      </template>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('common.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('common.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>

import { getConfig, addConfig, updateConfig } from '@/api/system/config'
import Editor from '@/components/Editor'
import UploadFileToVOD from '@/api/vod'

export default {
  name: 'CreateForm',
  props: {
    typeOptions: {
      type: Array,
      required: true
    }
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formType: 1,
      uploadLoading: false,
      uploadLoadingEn: false,
      uploadLoadingCn: false,
      uploadLoadingBm: false,
      uploadLoadingIn: false,
      // 表单参数
      form: {
        id: undefined,
        configName: undefined,
        configGroup: undefined,
        configKey: undefined,
        configValue: '',
        configValueEn: '',
        configValueCn: '',
        configValueBm: '',
        configValueIn: '',
        iosConfigValue: '',
        iosConfigValueEn: '',
        iosConfigValueCn: '',
        iosConfigValueBm: '',
        iosConfigValueIn: '',
        configType: '1',
        remark: undefined
      },
      open: false
    }
  },
  computed: {
    formTitle () {
      return this.formType === 1 ? this.$t('system.addConfig') : this.$t('system.editConfig')
    },
    configTypeOptions () {
      return [
        { value: '1', label: this.$t('system.configTypeInput') },
        { value: '2', label: this.$t('system.configTypeTextarea') },
        { value: '3', label: this.$t('system.configTypeRichText') },
        { value: '4', label: this.$t('system.configTypeImage') }
      ]
    },
    rules () {
      const valueRequired = { required: true, message: this.$t('system.configValueRequired') }
      return {
        configName: [{ required: true, message: this.$t('system.configNameRequired') }],
        configGroup: [{ required: true, message: this.$t('system.configGroupRequired') }],
        configKey: [{ required: true, message: this.$t('system.configKeyRequired') }],
        configValue: [valueRequired],
        configValueEn: [valueRequired],
        configValueCn: [valueRequired],
        configValueBm: [valueRequired],
        configValueIn: [valueRequired],
        iosConfigValue: [valueRequired],
        iosConfigValueEn: [valueRequired],
        iosConfigValueCn: [valueRequired],
        iosConfigValueBm: [valueRequired],
        iosConfigValueIn: [valueRequired]
      }
    }
  },
  methods: {
    handleChange (info) {
      const that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.configValue = fileName[0]
          that.uploadLoading = false
        }
      })
      that.uploadLoading = false
    },
    handleChangeIn (info) {
      const that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.configValueIn = fileName[0]
          that.uploadLoadingIn = false
        }
      })
      that.uploadLoadingIn = false
    },
    handleChangeBm (info) {
      const that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.configValueBm = fileName[0]
          that.uploadLoadingBm = false
        }
      })
      that.uploadLoadingBm = false
    },
    handleChangeEn (info) {
      const that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.configValueEn = fileName[0]
          that.uploadLoadingEn = false
        }
      })
      that.uploadLoadingEn = false
    },
    handleChangeCn (info) {
      const that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.configValueCn = fileName[0]
          that.uploadLoadingCn = false
        }
      })
      that.uploadLoadingCn = false
    },
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.form = {
        id: undefined,
        configName: undefined,
        configGroup: undefined,
        configKey: undefined,
        configValue: '',
        configType: '1',
        remark: undefined
      }
    },
    handleAdd () {
      this.reset()
      this.formType = 1
      this.open = true
    },
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const configId = row ? row.id : ids
      getConfig(configId).then(response => {
        this.form = response.data
        this.open = true
      })
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined) {
            updateConfig(this.form).then(() => {
              this.$message.success(this.$t('common.updateSuccess'), 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addConfig(this.form).then(() => {
              this.$message.success(this.$t('common.addSuccess'), 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
